<template>
  <div v-bind:class="{ 'version-spacing': !isLoggedIn }">
    <PageHeader title="Edit Profile"></PageHeader>
    <v-container class="page-bottom" v-if="user">
      <v-row>
        <v-col>
          <div class="bold-honey">User name: (Not editable)</div>
          <div class="mt-2">{{user.userName}}</div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            @submit.prevent="validate"
          >
            <v-text-field
              v-model="user.email"
              :rules="[rules.required, rules.email]"
              label="Email"
              required
            ></v-text-field>

            <v-text-field
              v-model="user.firstName"
              :rules="[rules.required]"
              label="First Name"
              required
            ></v-text-field>

            <v-text-field
              v-model="user.surname"
              :rules="[rules.required]"
              label="Surname"
              required
            ></v-text-field>

            <v-checkbox 
              v-model="user.receiveCompetitionNotifications"
              >
                <template v-slot:label>
                  <div>
                    Receive competition notifications
                  </div>
                </template>
            </v-checkbox>

            <v-checkbox 
              v-model="user.receiveMarketingMessages"
              class="mt-0"
              >
                <template v-slot:label>
                  <div>
                    Receive marketing messages
                  </div>
                </template>
            </v-checkbox>

            <v-btn
              block
              outlined
              large
              style="color: #ffffff !important;border: 1px solid #ffb300;"
              :disabled="!valid"
              color="success"
              class="mt-5"
              type="submit"
            >
              Save Profile
            </v-btn>
          </v-form>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <router-link :to="{name: 'profile'}">Back to profile</router-link>
        </v-col>
      </v-row>
    </v-container>

    <v-snackbar
      v-model="snackbar"
      :multi-line="true"
      centered
      color="error"
    >
      {{ snackbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <Spinner :overlay="overlay"></Spinner>
  </div>
</template>

<script>
import { CognitoUserAttribute } from "amazon-cognito-identity-js";
//import axios from 'axios'
import PageHeader from './../../components/PageHeader';
import Spinner from './../../components/Spinner';
import UserPool from "../../plugins/UserPool";
import Socket from "./../../plugins/socket";

export default {
  name: 'editprofile',
  components: {
    PageHeader,
    Spinner
  },
  data: () => ({
    valid: true,
    showPass: false,
    user: null,
    rules: {
      required: value => !!value || 'Required.',
      email: value => /.+@.+\..+/.test(value) || 'E-mail must be valid'
    },
    overlay: false,
    absolute: true,
    snackbar: false,
    snackbarText: ''
  }),
  computed: {
    isLoggedIn () {
      return this.$store.getters.isLoggedIn;
    },
    updatingUser () {
      return this.$store.getters.updatingUser;
    }
  },
  methods: {
    reconnect: function () {
      var scope = this;
      console.log('Connectionid is null when approving payment, must get new one.');
      Socket.connect(scope.$store.getters.userSub.userName);
      setTimeout(() => {
        scope.saveProfile();
      }, 2500);
    },
    validate () {
      var scope = this;
      var isValid = scope.$refs.form.validate();
      if(isValid){
        scope.overlay = true;
        scope.saveProfile();
      }
    },
    saveProfile () {
      var scope = this;
      scope.overlay = true;

      if(scope.$store.getters.connectionId === null){
        scope.reconnect();
        return;
      }

      var cognitoUser = UserPool.getCurrentUser();
      
      cognitoUser.getSession(function(error, session) {
      if(error) {
        console.log(error);
        return;
      }
      if(session) {
        cognitoUser.updateAttributes([new CognitoUserAttribute(
            {
              Name: "email",  
              Value: scope.user.email
            }
          ),
          new CognitoUserAttribute(
            {
              Name: "given_name",
              Value: scope.user.firstName
            }
          ),
          new CognitoUserAttribute(
            {
              Name: "family_name",
              Value: scope.user.surname
            }
          )], (err) => {
          if (err) {
            console.log("onFailure: ", err);
            scope.overlay = false;
            scope.snackbarText = err.message;
            scope.snackbar = true;
          } else {

            scope.$store.commit('setUpdatingUser', 1);
            scope.$store.dispatch('updateUser', scope.user).then(() => {
              
            }, error => {
                console.log(error);
            });            
          }
        });
      }
      });

    },
    getUser: function () {
      var scope = this;
      this.overlay = true;
      this.$store.dispatch('getUser', this.$store.getters.userSub.id).then(response => {
        scope.user = {
          ...response,
          receiveCompetitionNotifications: response.receiveCompetitionNotifications === 1 ? true : false,
          receiveMarketingMessages: response.receiveMarketingMessages === 1 ? true : false
        }
        scope.overlay = false;
      }, error => {
          scope.overlay = false;
          console.log(error);
      });
    },
    doneUpdatingUser: function () {
      this.overlay = false;
      this.$router.push({name: 'profile'});
    }
  },
  created () {
    this.getUser();
  },
  watch: {
      updatingUser (newVal) {
        if(newVal === 2) {
          this.doneUpdatingUser();
        }
      }
    }
}
</script>